import React from "react";
import { motion } from "framer-motion";
import { MaskedLines } from "./motion";

export default function PageHero({ overline, title, kicker, children, image, align = "left" }) {
  return (
    <section className="relative bg-[var(--vw-navy)] text-white overflow-hidden pt-36 lg:pt-44 pb-24 lg:pb-32" data-testid="page-hero">
      {image && (
        <>
          <div
            className="absolute inset-0 opacity-30 bg-cover bg-center"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(10,15,36,0.92), rgba(10,15,36,0.78))" }} />
        </>
      )}
      <div className="vw-grid-bg" />
      <div className="vw-noise" />

      <div className="relative vw-container">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="vw-rule-gold" />
          <span className="vw-overline vw-overline--gold">{overline}</span>
        </motion.div>

        <h1 className={`font-display text-4xl md:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tight max-w-5xl ${align === "center" ? "mx-auto text-center" : ""}`}>
          <MaskedLines text={title} />
        </h1>

        {kicker && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.6 }}
            className={`mt-8 text-base lg:text-lg text-white/70 leading-relaxed max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
          >
            {kicker}
          </motion.p>
        )}

        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.8 }}
            className={`mt-10 ${align === "center" ? "flex justify-center" : ""}`}
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
